import {
    DOCTOR_RANK_SUCCESS,
    DOCTOR_RANK_PENDING,
    DOCTOR_RANK_FAIL,
    ADD_DOCTOR_RANK_SUCCESS,
    ADD_DOCTOR_RANK_PENDING,
    ADD_DOCTOR_RANK_FAIL,
    UPDATE_DOCTOR_RANK_SUCCESS,
    UPDATE_DOCTOR_RANK_PENDING,
    UPDATE_DOCTOR_RANK_FAIL,
    SET_MESSAGE,
    DOWNLOAD_DOCTOR_RANK_SUCCESS,
    DOWNLOAD_DOCTOR_RANK_PENDING,
    DOWNLOAD_DOCTOR_RANK_FAIL,
} from "../types";
import { toast} from 'react-toastify'; 
import UserService from "../../services/user.service";

//All doctor Ranks

export const getDoctorRanks = (pageNumber, pageSize, searchQuery) => async(dispatch) => {
    dispatch({
        type: DOCTOR_RANK_PENDING,
        payload: { ranks: "isLoading" },
    });
    return await UserService.getDoctorRank(pageNumber, pageSize, searchQuery).then(
        (data) => {
            data.data.status ?
                dispatch({
                    type: DOCTOR_RANK_SUCCESS,
                    payload: { ranks: data.data},
                }) :
                dispatch({
                    type: DOCTOR_RANK_FAIL,
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: DOCTOR_RANK_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    });
};

    //add doctor RANK
export const addDoctorRanks = (body) => async(dispatch) => {
    dispatch({
        type: ADD_DOCTOR_RANK_PENDING,
        payload: { addRanks: "isLoading" },
    });
    return await UserService.addDoctorRank(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: ADD_DOCTOR_RANK_SUCCESS,
                    payload: { addRanks : data.data.status },
                }) :
                dispatch({
                    type: ADD_DOCTOR_RANK_FAIL,
                    payload: { addRanks : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: ADD_DOCTOR_RANK_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: ADD_DOCTOR_RANK_FAIL
        })
      });
};

//update doctor rank
export const updateDoctorRanks = (body) => async(dispatch) => {
    dispatch({
        type: UPDATE_DOCTOR_RANK_PENDING,
        payload: { updateRanks: "isLoading" },
    });
    return await UserService.updateDoctorRank(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: UPDATE_DOCTOR_RANK_SUCCESS,
                    payload: { updateRanks : data.data.status },
                }) :
                dispatch({
                    type: UPDATE_DOCTOR_RANK_FAIL,
                    payload: { updateRanks : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: UPDATE_DOCTOR_RANK_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: UPDATE_DOCTOR_RANK_FAIL
        })
      });
}

// download doctor rank
export const downloadDoctorRank = () => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_DOCTOR_RANK_PENDING,
    payload: { downloadDoctorRank: "isLoading" },
  });
  try {
    const response = await UserService.downloadDoctorRank({
      responseType: "blob",
    });
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
      : "DoctorRank.csv";
    const blob = new Blob([response.data], {
      type: "text/csv",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    toast.success("Doctor Rank file downloaded successfully!", {
      autoClose: 2000,
    });
    dispatch({
      type: DOWNLOAD_DOCTOR_RANK_SUCCESS,
      payload: { downloadDoctorRank: true },
    });
  } catch (error) {
    console.error("Error downloading Doctor Rank file:", error);
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error("Failed to download the Doctor Rank file.", { autoClose: 2000 });
    dispatch({
      type: DOWNLOAD_DOCTOR_RANK_FAIL,
      payload: { downloadDoctorRank: false },
    });
  }
};